import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarMasculino from "../assets/images/parcas.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Parcas() {
  useTrackPageView();
  useTimeOnPage();

  const handleWhatsappClick = async () => {

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "leads",
      category: "whatsapp",
      action: "click",
      label: "geral_cta_main",
    });

    await trackEvent("whatsapp_click", {
      buttonLocation: "masculino_cta_main",
    });

    window.open("https://chat.whatsapp.com/EFO7WzAaOyxA5DQJB0dSMF?mode=gi_t", "_blank");
  };

  return (
    <LandingCategory
      avatar={avatarMasculino}
      titleTop="CHEGA DE PAGAR"
      titleBottom="CARO EM ROUPAS E ACESSÓRIOS!"
      highlightWord="EM ROUPAS E ACESSÓRIOS!"
      members="10.000"
      description="Receba as melhores promoções de tênis ORIGINAIS todos os dias! 👟🔥"
      whatsappLink="https://chat.whatsapp.com/EFO7WzAaOyxA5DQJB0dSMF?mode=gi_t"
      // telegramLink="https://t.me/seu-link"
      theme={themes.masculino}
      onWhatsappClick={handleWhatsappClick}
    />
  );
}